import { MenuItem } from '@fiverr-private/dropdown';

export default MenuItem;
